import { useTranslation } from "react-i18next";
import { Box, Typography, SxProps, Skeleton } from "@mui/material";
import { OverallJobsIcon, RatingIcon, ReviewsIcon } from "../../assets/icons/service-details-icons";

const iconsMapper = {
  overallJobs: <OverallJobsIcon />,
  completedJobs: <OverallJobsIcon />,
  rating: <RatingIcon />,
  reviewsCount: <ReviewsIcon />,
};

interface StatusCardProps {
  status: {
    title: string;
    value?: number;
  };
}

const cardContainerStyles: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  padding: "16px",
  borderRadius: "16px",
  border: "1px solid #EAECF0",
  background: "var(--White, #FFF)",
  flex: 1,
};

const valueTextStyles: SxProps = {
  fontFamily: "Montserrat",
  color: "var(--Dark---1000, #111)",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
};

const titleTextStyles: SxProps = {
  fontFamily: "Montserrat",
  color: "var(--Dark---600, #707070)",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
};

export const StatusCard = ({ status: { title, value } }: StatusCardProps) => {
  const { t } = useTranslation("goService", {
    keyPrefix: "statusCard",
  });

  return (
    <Box sx={cardContainerStyles}>
      {iconsMapper[title as keyof typeof iconsMapper]}
      <Typography sx={valueTextStyles}>{value}</Typography>
      <Typography sx={titleTextStyles}>{t(title, { count: value })}</Typography>
    </Box>
  );
};

export const StatusCardLoader = () => {
  return (
    <Box sx={cardContainerStyles}>
      <Skeleton variant="circular" width={24} height={24} />
      <Skeleton variant="text" width={60} height={32} />
      <Skeleton variant="text" width={100} height={28} />
    </Box>
  );
};
